$(function() {
  var headerSection = $('#shopify-section-static-header');
  
  if (headerSection.length > 0) {
    var header = headerSection.find('.header');
    if (header.is('[data-sticky-header]')) {
      headerSection.addClass('-sticky');
    }
  }

  // Yotpo Write a Review link
  function insertWriteReviewLink() {
    if ($('.product-details.desktop .yotpo.bottomLine.yotpo-medium').length > 0 || $('.product-details.desktop .yotpo.bottomLine.yotpo-small').length > 0) {
        $("<a class='yotpo-bottomline text-m' id='top-write-review'>write a review</a>").appendTo('.product-details.desktop .yotpo.bottomLine .yotpo-display-wrapper .standalone-bottomline').click(function() {
            $('.write-review-button').click();
        })
    } else {
        setTimeout(insertWriteReviewLink, 100);
    }
  }

  if ($('#shopify-section-static-product').length > 0) {
    insertWriteReviewLink();
  }

  var slider = $('.glide');

  if (slider.length > 0) {
    slider.each(function() {
      var perView = $(this).data('per-view');
      var perViewTablet = $(this).data('per-view-tablet');
      var focusAt = $(this).data('focus-at');
      var startAt = $(this).data('start-at');
      var mobilePeek = $(this).data('mobile-peek');
      var tabletPeek = $(this).data('tablet-peek');
      var type = $(this).data('glide-type');
      var glideEl = $(this)[0];
      var glide = new Glide(glideEl, {
        type: (type) ? type : 'slider',
        perView: (perView) ? perView : 5,
        swipeThreshold: false,
        dragThreshold: false,
        focusAt: (focusAt) ? focusAt : 0,
        startAt: (startAt) ? startAt : 0,
        breakpoints: {
          480: {
            perView: 1,
            swipeThreshold: 80,
            dragThreshold: 120,
            peek: (mobilePeek) ? mobilePeek : 0
          },
          720: {
            perView: (perViewTablet) ? perViewTablet : 1,
            swipeThreshold: 80,
            dragThreshold: 120,
            peek: (tabletPeek) ? tabletPeek : 0
          },
          1020: {
            perView: (perView == 1) ? 1 : 3,
            swipeThreshold: 80,
            dragThreshold: 120,
            peek: (tabletPeek) ? tabletPeek : 0
          }
        },
      });
      glide.mount();
    })
  }
});